module.exports = __webpack_public_path__ + "static/media/programoutline.146a17a0.svg";